import { CheckRounded, ClearRounded } from '@mui/icons-material';
import { Status, StatusColor } from 'types/status';
import { ReactComponent as BadIcon } from '../assets/images/icons/bad-icon.svg';
import MDTypography from './../components/MDTypography/index';
import { Box, Card, Icon, IconButton, Paper, SvgIcon } from '@mui/material';

export const Severity = {
  Error: 0,
  Warning: 1,
  Info: 2,
  Success: 3,
};

export const SeverityColor = {
  [Severity.Error]: StatusColor[Status.Bad],
  [Severity.Warning]: StatusColor[Status.Medium],
  [Severity.Info]: StatusColor[Status.Default],
  [Severity.Success]: StatusColor[Status.Good],
};

export const SeverityIcon = {
  [Severity.Error]: <ClearRounded />,
  [Severity.Warning]: (
    <SvgIcon
      sx={{
        color: '#fff',
        // scale: '1.5',
        '&:hover': {
          color: '#fff',
        },
      }}
    >
      <BadIcon />
    </SvgIcon>
    // <BadIcon scale={2} fontSize={42} />
    // <MDTypography
    //   variant="subtitle2"
    //   fontSize={22}
    //   fontFamily="Sono"
    //   fontWeight="regular"
    //   sx={{ marginTop: -0.9 }}
    // >
    //   !
    // </MDTypography>
  ),
  [Severity.Info]: (
    <MDTypography
      variant="subtitle2"
      fontSize={22}
      fontFamily="Sono"
      fontWeight="regular"
      sx={{ marginTop: -1.1, transform: 'rotate(-180deg)', marginLeft: -0.25 }}
    >
      !
    </MDTypography>
  ),
  [Severity.Success]: <CheckRounded />,
};
